import { http } from "@common";
import endpoint from "../endpoint_cis";

export default {
    IsUserEnabled: (data) => {
        return http.get(endpoint.studentId.IsUserEnabled_get, data);
    },
};